<template>
  <div>
    <el-table :data="orderList"  size="small" border>
      <!-- <el-table-column prop="id"  label="订单ID" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
         
        </template>
      </el-table-column> -->

      <!-- <el-table-column prop="fromUserId" label="转出账号"></el-table-column> -->
      <el-table-column prop="userId" label="用户ID" fixed></el-table-column>
      <el-table-column prop="orderId" label="订单ID" fixed></el-table-column>
      <el-table-column prop="oppositeUserId" label="对手方用户ID" fixed></el-table-column>
      <el-table-column prop="oppositeOrderId" label="对手方订单ID" fixed></el-table-column>
     
       <el-table-column prop="symbolId"  label="币种Id" >
        <template slot-scope="scope">
          <span v-if="scope.row.symbolId">{{scope.row.symbolId}}</span>
          <span v-else>--</span>
          
        </template>
      </el-table-column>
       <el-table-column prop="timestamp"  label="成交时间" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.timestamp">{{new Date(scope.row.timestamp).toLocaleString()}}</span>
         
          
        </template>
      </el-table-column>
      <el-table-column prop="orderType"  label="订单类型" >
        <template slot-scope="scope">
          <span v-if="scope.row.orderType==1">限价单</span>
          <span v-else>市价单</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderSide"  label="下单方向" >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.orderSide==1">买入</el-tag>
          <el-tag type="danger" v-else>卖出</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="timeInForce"  label="有效方式" >
        <template slot-scope="scope">
          <span v-if="scope.row.timeInForce==1">GTC</span>
          <span v-else-if="scope.row.timeInForce==1">FOK</span>
          <span v-else-if="scope.row.timeInForce==1">IOC</span>
          <span v-else>GTX</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="成交价格" ></el-table-column>
      <el-table-column prop="quantity" label="成交数量" ></el-table-column>
      <el-table-column prop="fee" label="手续费" ></el-table-column>
      <el-table-column prop="marginUnfrozen" label="保证金解冻" ></el-table-column>
      <el-table-column prop="feeCoin" label="手续费币种" ></el-table-column>
      <!-- <el-table-column prop="avgPrice" label="均价" ></el-table-column>
      <el-table-column prop="executedQty" label="已成交数量" ></el-table-column>
      <el-table-column prop="cumQuote" label="成交额" ></el-table-column> -->
      <el-table-column prop="liquidityFlag"  label="挂单类型" >
        <template slot-scope="scope">
          <span v-if="scope.row.liquidityFlag==1">taker</span>
          <span v-else>maker</span>
        </template>
      </el-table-column>
      <el-table-column prop="execType"  label="成交类型" >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.execType==2">部分成交</el-tag>
          <el-tag type="success" v-else-if="scope.row.execType==3">全部成交</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="forceClose"  label="是否是强平成交" >
        <template slot-scope="scope">
          <el-tag type='danger' v-if="scope.row.forceClose===false">否</el-tag>
          <el-tag type="success" v-else-if="scope.row.forceClose===true">是</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="liquidityFlag"  label="币种Id" >
        <template slot-scope="scope">
          <span v-if="scope.row.liquidityFlag">{{scope.row.liquidityFlag}}</span>
          <span v-else>--</span>
          
        </template>
      </el-table-column>
      <el-table-column prop="orderType"  label="订单类型" >
        <template slot-scope="scope">
          <span v-if="scope.row.orderType==1">限价单</span>
          <span v-else>市价单</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderSide"  label="下单方向" >
        <template slot-scope="scope">
          <span v-if="scope.row.orderSide==1">买入</span>
          <span v-else>卖出</span>
        </template>
      </el-table-column>
      <el-table-column prop="timeInForce"  label="有效方式" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.timeInForce==1">GTC</span>
          <span v-else-if="scope.row.timeInForce==1">FOK</span>
          <span v-else-if="scope.row.timeInForce==1">IOC</span>
          <span v-else>GTX</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" ></el-table-column>
      <el-table-column prop="origQty" label="数量" ></el-table-column>
      <el-table-column prop="marginFrozen" label="冻结资金" ></el-table-column>
      <el-table-column prop="avgPrice" label="均价" ></el-table-column>
      <el-table-column prop="executedQty" label="已成交数量" ></el-table-column>
      <el-table-column prop="cumQuote" label="成交额" ></el-table-column>

      <el-table-column prop="state"  label="订单状态" >
        <template slot-scope="scope">
          <span v-if="scope.row.state==1">新建</span>
          <span v-else-if="scope.row.state==2">部分成交</span>
          <span v-else-if="scope.row.state==3">全部成交</span>
          <span v-else-if="scope.row.state==4">用户撤销</span>
          <span v-else-if="scope.row.state==5">下单失败</span>
          <span v-else-if="scope.row.state==6">已过期</span>
          <span v-else>GTX</span>
        </template>
      </el-table-column> -->


     
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
   
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'FinanceTradeList',

  data() {
    return {
      page:1,size:25,
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('financeTrade', [
      'updateDividendStatus',
      'updateMark'
    ]),
    ...mapMutations('financeTrade', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    pageChanged(e) {
      this.page=e.page
      this.size=e.size
      this.$emit('refresh', {page:this.page,size:this.size});
    },
    handleDel(row){
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
   
  },
  computed: {
    ...mapGetters('financeTrade', ['userList',]),
    ...mapState('financeTrade', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible','blockInfoList','orderList'
    ])
  }
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
